import { Component } from 'shimmer'
import { Loader } from '@/utils/Loader'
import { webGL } from '@/webGL/WebGL'

import gsap from 'gsap'

import {
  DirectionalLight,
  AmbientLight
} from 'three'

const basePosBtn = {x: 9.2, y: -1201.5, z: -4.8}
const pushedPosBtn = {x: 10, y: -1202.5, z: -4.8}

export class EnvLetters extends Component {
  constructor () {
    super()

    this.create = this.create.bind(this)
    this.onUp = this.onUp.bind(this)
    this.onDown = this.onDown.bind(this)

    this.create()

    this.promise = new Promise((resolve, reject) => {
      this.resolve = resolve
      this.reject = reject
    })
  }

  create () {
    Loader.load('/objects/environments/interaction--3.glb', false, obj => {
      obj.receiveShadow = true
    }).then(obj => {
      this.env = obj

      this.btn = this.env.getObjectByName('btn')

      webGL.scene.add(this.env)
      this.resolve()
    })


    this.directional = new DirectionalLight(0xffffff, 1.5)
    this.directional.position.set(-15, 15, 20)
    this.directional.lookAt(0, 0, 0)
    this.directional.castShadow = true
    this.directional.shadow.bias = -0.0004
    this.directional.shadow.camera.far = 70
    this.directional.shadow.camera.near = 0.001
    this.directional.shadow.mapSize.width = 1024
    this.directional.shadow.mapSize.height = 1024
    this.directional.shadow.camera.updateProjectionMatrix()
    webGL.scene.add(this.directional)

    this.ambient = new AmbientLight(0xffffff, .4)
    webGL.scene.add(this.ambient)
  }

  onUp () {
    this.ease = gsap.to(this.btn.position, {
      x: pushedPosBtn.x,
      // y: pushedPosBtn.y,
      z: pushedPosBtn.z,
      duration: .5,
      ease: 'power4.inOut',
    })
  }

  onDown () {
    this.ease = gsap.to(this.btn.position, {
      x: basePosBtn.x,
      // y: basePosBtn.y,
      z: basePosBtn.z,
      duration: .5,
      ease: 'power4.inOut',
    })
  }

  onDestroy () {
    this.env.traverse(child => {
      if (child.isMesh) {
        child.material.dispose()
        child.geometry.dispose()
      }
    })

    webGL.scene.remove(this.directional)
    webGL.scene.remove(this.ambient)
    webGL.scene.remove(this.env)

    this.destroy()
  }
}